// extracted by mini-css-extract-plugin
export var assigneeBadge = "_np-0";
export var assigneeDetails = "_np-1";
export var assigneeInfo = "_np-2";
export var dropdownContainer = "_np-4";
export var dropdownImage = "_np-5";
export var editAssigneeInfo = "_np-3";
export var editAssigneeModalContainer = "_np-6";
export var hidden = "_np-8";
export var input = "_np-7";